export default "__VITE_ASSET__Vf8Xr3EM__"